// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_DEL_SHOPPING_SUCCESS,
} from './constants';

export function delShoppingSuccess() {
  return {
    type: COMMON_DEL_SHOPPING_SUCCESS,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_DEL_SHOPPING_SUCCESS:
      return {
        ...state,
        fetchGetShoppingCarSuccess: JSON.parse(localStorage.getItem('shoppingCartData')),
        fetchGetShoppingCarTotal: JSON.parse(localStorage.getItem('shoppingCartData')).length
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/delShoppingSuccess.js